type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const logger = {
  log: (level: LogLevel, message: string, error?: Error) => {
    const timestamp = new Date().toISOString();
    const formattedMessage = `[${timestamp}] [${level.toUpperCase()}] ${message}`;

    if (error) {
      console[level](formattedMessage, '\nError:', error.message);
    } else {
      console[level](formattedMessage);
    }
  },
  debug: (message: string) => logger.log('debug', message),
  info: (message: string) => logger.log('info', message),
  warn: (message: string) => logger.log('warn', message),
  error: (message: string, error?: Error) => logger.log('error', message, error)
};

export default logger;
